import { SwapKitApi } from "@swapkit/api";

import { invariant } from "@coinbot/forge-api/helpers";

import { ForgeThorname } from "../../models";
import { getTHORNameByName } from "./getTHORNameByName";

export const getTHORNamesByOwner = async (
  owner: string | null | undefined,
): Promise<ForgeThorname[]> => {
  try {
    invariant(owner && typeof owner === "string", "Owner address is required");

    const thornames = await SwapKitApi.getTHORNamesByOwner(owner?.toLowerCase());

    invariant(thornames && Array.isArray(thornames), "No thornames found");

    const results = (await Promise.all(thornames?.map(getTHORNameByName)))?.filter(
      Boolean,
    ) as ForgeThorname[];

    return results;
  } catch (err) {
    console.error("err when getting thornames", err);
    return [];
  }
};
